import { Button } from "@/components/ui/button";
import { ArrowRight, Zap } from "lucide-react";
import { Link } from "react-router-dom";

const WebsiteCTA = () => {
  return (
    <section className="py-10 md:py-14 bg-gradient-to-br from-secondary/10 via-primary/5 to-secondary/10">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 bg-secondary/20 px-6 py-3 rounded-full mb-6 border border-secondary/30">
              <Zap className="w-5 h-5 text-secondary" />
              <span className="text-secondary font-semibold">Add Firepower to Your Marketing</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-foreground">
              Need a High-Converting <span className="text-secondary">Lead Generation Website?</span>
            </h2>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
              Transform your online presence with a custom website designed for one thing: 
              converting visitors into high-quality leads. Optimized funnels, professional design, 
              and conversion-focused architecture.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button variant="premium" size="lg" asChild>
              <Link to="/website-design">
                Explore Website Services <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>
            <Button variant="outline" size="lg" asChild>
              <a href="/do-you-qualify">
                Schedule Strategic Review
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WebsiteCTA;
